"use client";

import { c as _c } from "react/compiler-runtime";
import { useActionState, useEffect, useRef } from "react";
import { sendContactMessage, type ContactFormState } from "@/lib/actions/contact-actions";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { FormError } from "@/components/ui/form-error";
import { Loader2, Send, CheckCircle2 } from "lucide-react";
export function ContactForm() {
  const $ = _c(29);
  const [state, formAction, isPending] = useActionState(sendContactMessage, null);
  const formRef = useRef(null);
  let t0;
  if ($[0] !== state?.success) {
    t0 = () => {
      if (state?.success) {
        formRef.current?.reset();
      }
    };
    $[0] = state?.success;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== state) {
    t1 = [state];
    $[2] = state;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden="true" className="absolute left-[-9999px] top-[-9999px] h-0 w-0 overflow-hidden"><label htmlFor="website">Website</label><input id="website" name="website" type="text" tabIndex={-1} autoComplete="off" /></div>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Label htmlFor="from">From</Label>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isPending) {
    t4 = <Input id="from" name="from" type="email" placeholder="you@example.com" autoComplete="email" maxLength={254} required={true} disabled={isPending} />;
    $[6] = isPending;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="text-xs text-muted-foreground">We'll reply to this address.</p>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <div className="space-y-2">{t3}{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Label htmlFor="message">Message</Label>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isPending) {
    t8 = <div className="space-y-2">{t7}<Textarea id="message" name="message" placeholder="Tell us what's on your mind..." rows={8} minLength={10} maxLength={5000} required={true} disabled={isPending} className="min-h-[180px] resize-y" /></div>;
    $[12] = isPending;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = state?.error ?? null;
  let t10;
  if ($[14] !== t9) {
    t10 = <FormError message={t9} />;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== state?.success) {
    t11 = state?.success && <div className="flex items-start gap-2 rounded-md bg-primary/10 p-3 text-sm text-foreground"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-primary" /><span>Thanks — your message was sent. We'll get back to you soon.</span></div>;
    $[16] = state?.success;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== isPending) {
    t12 = isPending ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Sending...</> : <><Send className="mr-2 h-4 w-4" />Send</>;
    $[18] = isPending;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== isPending || $[21] !== t12) {
    t13 = <Button type="submit" disabled={isPending} className="w-full sm:w-auto">{t12}</Button>;
    $[20] = isPending;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t13 || $[26] !== t6 || $[27] !== t8) {
    t14 = <form ref={formRef} action={formAction} className="space-y-5">{t2}{t6}{t8}{t10}{t11}{t13}</form>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t13;
    $[26] = t6;
    $[27] = t8;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}